import './restructuration.css';
import React, { useEffect, useState } from 'react';
import AppelerApi from '../../../services/appeler-api.service';
import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from '@mui/material';
import websocketService from '../../../services/websocket.service';


const Restructuration = () => {

    const [valeurEntree, _] = useState('');
    const [restructurationLancee, lancerRestructuration] = useState(false);
    const [avancement, modifierAvancement] = useState({etape: '', statut: 0, numeroEtape: 0, totalEtapes: 0});

    const lancerRestructuration2025 = () => {
        AppelerApi.post('/restructurer-donnees-2025', {}).then(() => {
            lancerRestructuration(true);
        });
    };

    const majStatutRestructuration2025 = (donnees) => {
        modifierAvancement(donnees);
    };

    const afficherStatut = (statut) => {
        switch (statut) {
            case 0:
                return 'en cours';
            case 1:
                return 'terminé';
            case 2:
                return 'en erreur';
            default:
                return 'inconnu';
        }
    };

    const styleAvancement = (avancement) => {
        const pourcent = Math.floor(100 * avancement.numeroEtape / avancement.totalEtapes);
        let style = {
            width: `${pourcent}%`
        };
        if (avancement.statut === 1) {
            style.backgroundColor = 'green';
        } else if (avancement.statut === 2) {
            style.backgroundColor = 'red';
        }
        return style;
    };

    useEffect(() => {
        websocketService.connecterWebSocket(true);
        websocketService.enregistrerFonction('majStatutRestructuration2025', majStatutRestructuration2025);
    }, [valeurEntree]);

    return (
        <div className="conteneur">
            <h1>Gestion des modifications de structure de données</h1>
            {(!restructurationLancee &&
            <div className="bloc-fonctionnel">
                <Button variant="contained" onClick={lancerRestructuration2025}>Lancer restructuration clients/articles/remises</Button>
            </div>
            )}
            {(restructurationLancee &&
            <div className="bloc-fonctionnel">
                <div className="bloc-avancement">
                    <div className="titre-avancement">{avancement.etape} {afficherStatut(avancement.statut)}</div>
                    <div className="barre-avancement">
                        <div className="avancement-courant" style={styleAvancement(avancement)}></div>
                    </div>
                </div>
            </div>
            )}
        </div>
    );
};

export default Restructuration;